import { useMemo, useState } from "react";
import useGallery, { useFiltered } from "@/hooks/useGallery";
import FilterBar from "@/components/FilterBar";
import GalleryGrid from "@/components/GalleryGrid";
import Lightbox from "@/components/Lightbox";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/Seo";

const PHOTO_CATEGORIES = [
  "All",
  "Drone",
  "Roadworks",
  "Structures",
  "People",
  "Night Works",
  "Depots",
  "Plant",
  "Traffic Management",
  "Events",
  "General",
];

export default function PhotographyPage() {
  const { items, loading } = useGallery();
  const photos = useMemo(() => items.filter((i) => i.type === "photo"), [items]);
  const [filter, setFilter] = useState("All");
  const [activeId, setActiveId] = useState(null);
  const filtered = useFiltered(photos, filter);

  return (
    <div className="px-5 sm:px-8 lg:px-10 pt-10 lg:pt-12 pb-16">
      <Seo
        title="Still Photography"
        description="Project photography, people, plant, progress, and infrastructure captured for the UK highways sector."
        path="/photography"
      />
      <PageHeader
        eyebrow="Stills"
        title="Still Photography"
        intro="Project photography, people, plant, progress, and infrastructure captured for the highways sector."
        testid="photography-header"
      />
      <div className="mt-10 mb-8 overflow-x-auto -mx-2 px-2">
        <FilterBar
          active={filter}
          onChange={setFilter}
          categories={PHOTO_CATEGORIES}
        />
      </div>
      {loading ? (
        <div className="text-[#737373] text-xs tracking-[0.24em] uppercase py-20 text-center">
          Loading…
        </div>
      ) : (
        <GalleryGrid items={filtered} onOpen={setActiveId} />
      )}
      {activeId !== null && (
        <Lightbox
          items={filtered}
          activeId={activeId}
          onClose={() => setActiveId(null)}
          onChange={setActiveId}
        />
      )}
    </div>
  );
}
